module.exports = __webpack_public_path__ + "static/media/sociana1.946958c1.webp";